type CallEntry = {
  additionalData?: Record<string, unknown>;
};

export type EmergencyCallsMap = Record<string, CallEntry>;

export const isCallerIDFromOrg = (
  org: string | null | undefined,
  emergencyCalls: EmergencyCallsMap | null | undefined,
  callerID: string | null | undefined,
): boolean => {
  if (!org || !emergencyCalls || !callerID) return false;

  const callerIDsFromOrg = Object.keys(emergencyCalls).filter(num => {
    const entry = emergencyCalls[num];
    return (
      entry?.additionalData && Object.keys(entry.additionalData).includes(org)
    );
  });
  return callerIDsFromOrg.includes(callerID);
};
